module.exports = __webpack_public_path__ + "img/tick.67a6b78f.png";